/**
 * Loads server-rendered vendor prev/next HTML from collection?vendor-nav template.
 * Links are real <a href> from Liquid (SEO-friendly after injection).
 */
(function () {
  function extractFragment(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nav = doc.querySelector('[data-vendor-nav-fragment]');
    if (!nav) return null;
    return {
      found: nav.getAttribute('data-found') === 'true',
      page: parseInt(nav.getAttribute('data-page') || '1', 10),
      pages: parseInt(nav.getAttribute('data-pages') || '1', 10),
      html: nav.innerHTML.trim(),
      hasLinks: Boolean(nav.querySelector('a.product-vendor-pager__link')),
    };
  }

  function buildUrl(vendor, handle, page) {
    const params = new URLSearchParams();
    params.set('view', 'vendor-nav');
    params.set('filter.p.vendor', vendor);
    params.set('for_handle', handle);
    if (page > 1) params.set('page', String(page));
    return `/collections/all?${params.toString()}`;
  }

  async function fetchFragment(vendor, handle, page) {
    const res = await fetch(buildUrl(vendor, handle, page), { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`vendor-nav HTTP ${res.status}`);
    return extractFragment(await res.text());
  }

  function renderGrid(root, innerHtml, prevLabel, nextLabel) {
    const doc = new DOMParser().parseFromString(`<div>${innerHtml}</div>`, 'text/html');
    const prev = doc.querySelector('.product-vendor-pager__link--prev');
    const next = doc.querySelector('.product-vendor-pager__link--next');

    if (prev) {
      const label = prev.querySelector('.product-vendor-pager__label');
      if (label) label.textContent = prevLabel;
    }
    if (next) {
      const label = next.querySelector('.product-vendor-pager__label');
      if (label) label.textContent = nextLabel;
    }

    let grid = '<div class="product-vendor-pager__grid">';
    if (prev) {
      grid += prev.outerHTML;
    } else {
      grid += '<span class="product-vendor-pager__spacer" aria-hidden="true"></span>';
    }
    if (next) {
      grid += next.outerHTML;
    } else {
      grid += '<span class="product-vendor-pager__spacer" aria-hidden="true"></span>';
    }
    grid += '</div>';

    root.classList.remove('product-vendor-pager--loading');
    root.removeAttribute('aria-busy');
    root.innerHTML = grid;
  }

  async function initPager(root) {
    const vendor = (root.dataset.vendor || '').trim();
    const handle = (root.dataset.productHandle || '').trim();
    const prevLabel = root.dataset.prevLabel || 'Previous';
    const nextLabel = root.dataset.nextLabel || 'Next';

    if (!vendor || !handle) {
      root.remove();
      return;
    }

    try {
      let page = 1;
      let totalPages = 1;
      let result = null;

      while (page <= totalPages) {
        result = await fetchFragment(vendor, handle, page);
        if (!result) break;
        totalPages = result.pages || 1;
        if (result.found && result.hasLinks) break;
        if (result.found && !result.hasLinks) {
          root.remove();
          return;
        }
        page += 1;
      }

      if (!result || !result.found) {
        root.remove();
        return;
      }

      if (!result.hasLinks) {
        root.remove();
        return;
      }

      renderGrid(root, result.html, prevLabel, nextLabel);
    } catch (err) {
      console.warn('[product-vendor-nav]', err);
      root.remove();
    }
  }

  function boot() {
    document.querySelectorAll('[data-product-vendor-pager]').forEach((root) => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(() => initPager(root), { timeout: 3000 });
      } else {
        setTimeout(() => initPager(root), 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
